var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p5 mt-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-3 mx-auto"},[_vm._v(" Please wait... ")])])])
}]

export { render, staticRenderFns }